import { Component } from '@angular/core';

@Component({
  selector: 'generate-progress-modal',
  templateUrl: './generate-progress-modal.component.html',
  styleUrls: ['./generate-progress-modal.styles.scss']
})
export class GenerateProgressDialogComponent { }
